import { includes, some } from 'lodash';
import { flattenAnswers } from './flattenAnswers';

export function checkIfContainsOneOf(profile, condition) {
  const clonedProfile = flattenAnswers(profile);
  // check if an array | string contains one of the values in the ifValue
  const { ifId, ifValue } = condition;
  const profileValue = clonedProfile[ifId];
  // This is commented so we can specify if it was skipped by passing undefined
  // if(!_.hasIn(profile, ifId)){
  //     // console.log(ifId, 'not found');
  //     return false
  // }
  if (Array.isArray(profileValue)) {
    // const flattenValues = profileValue.map(({ value }) => value );
    // console.log("check if contains","ifId:",ifId, "profileValue:",profileValue);
    if (Array.isArray(ifValue)) {
      const checks = ifValue.map((value) => includes(profileValue, value));
      // console.log("check if", profileValue, "contains:",ifValue, "Result::", checks);
      return some(checks, (check) => check === true);
    }

    return includes(profileValue, ifValue);
  }
  // In case the profile value is not array
  // console.log("Check when ifId is not array. ifId:",ifId, "ifValue:", ifValue);
  return some(ifValue, (value) => value === profileValue);
}
